import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { IconButton, Typography, Collapse, Stack, Box } from '@mui/material';
import Iconify from './Iconify';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

function CollapseSection({
  children,
  title,
  sx = { marginTop: '24px', marginBottom: '24px' },
  defaultExpanded = false,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <Box sx={sx}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box>
          <Typography sx={{ flex: 1 }} variant="body4" component="div">
            {title}
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }}></Box>
        <Box>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <Iconify
              width={14}
              height={14}
              icon={'material-symbols:keyboard-arrow-down'}
            />
          </ExpandMore>
        </Box>
      </Stack>
      <Collapse
        in={expanded}
        timeout="auto"
        unmountOnExit
        sx={{ marginTop: '16px' }}
      >
        {children}
      </Collapse>
    </Box>
  );
}

CollapseSection.propTypes = {
  children: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default CollapseSection;
